/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Filter_AllInputs */

const en_us2_search_filter_all = /** @type {(inputs: Search_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const pt_br2_search_filter_all = /** @type {(inputs: Search_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

const es_419_search_filter_all = /** @type {(inputs: Search_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

const pt_pt2_search_filter_all = /** @type {(inputs: Search_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

const fr_fr2_search_filter_all = /** @type {(inputs: Search_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous`)
};

const de_de2_search_filter_all = /** @type {(inputs: Search_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

const it_it2_search_filter_all = /** @type {(inputs: Search_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Search_Filter_AllInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_filter_all = /** @type {((inputs?: Search_Filter_AllInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Filter_AllInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_filter_all(inputs)
	if (locale === "es-419") return es_419_search_filter_all(inputs)
	if (locale === "pt-PT") return pt_pt2_search_filter_all(inputs)
	if (locale === "fr-FR") return fr_fr2_search_filter_all(inputs)
	if (locale === "de-DE") return de_de2_search_filter_all(inputs)
	if (locale === "it-IT") return it_it2_search_filter_all(inputs)
	return en_us2_search_filter_all(inputs)
});
export { search_filter_all as "search.filter_all" }